export default "__VITE_ASSET__D4l9HEPi__"